const core = {
	login: 'api/auth/login',
	register: 'api/auth/register',
	refresh: 'api/auth/refresh',
	mfaVerify: 'api/auth/mfa/verify',
	server: '__API_SERVER__'
}
export { core }

